import { render, staticRenderFns } from "./RadioIcon.vue?vue&type=template&id=53045107&scoped=true"
import script from "./RadioIcon.vue?vue&type=script&lang=ts"
export * from "./RadioIcon.vue?vue&type=script&lang=ts"
import style0 from "./RadioIcon.vue?vue&type=style&index=0&id=53045107&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53045107",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53045107')) {
      api.createRecord('53045107', component.options)
    } else {
      api.reload('53045107', component.options)
    }
    module.hot.accept("./RadioIcon.vue?vue&type=template&id=53045107&scoped=true", function () {
      api.rerender('53045107', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/RadioIcon.vue"
export default component.exports